import React, { useState, useContext, useEffect  } from 'react';
import { ErpContext } from '../../context/ErpContext.js';
import { TextField, Button, Typography, Container } from '@mui/material';

const GestionNegocioComponent = () => {
    const { negocios, getNegocio, postNegocio,isNavbarCollapsed, } = useContext(ErpContext); 

    const [descripcionNegocio, setDescripcionNegocio] = useState(''); //Define el estado local descripcionNegocio, que almacena el valor del input donde el usuario escribe la descripción de la nueva ubicación. setDescripcionUbicacion es la función para actualizar ese estado.

    // Ejecutar fetchNegocio solo cuando se monte este componente
    useEffect(() => {
        getNegocio(); 
    }, []);

  const handleNegocioSubmit = (e) => {
    e.preventDefault();
    postNegocio(descripcionNegocio);
    setDescripcionNegocio(''); // Limpiar el input después de la creación
  };

  return (
    <Container className="containerModuloDiseñoGeneral">
      <form onSubmit={handleNegocioSubmit}>
        <TextField
          label="Descripción Negocio"
          variant="outlined"
          fullWidth
          value={descripcionNegocio}
          onChange={(e) => setDescripcionNegocio(e.target.value)}
        />
        <Button variant="contained" color="primary" type="submit" style={{ marginTop: '10px' }}>
          Agregar Negocio
        </Button>
      </form>

      <div style={{ marginTop: '20px' }}>
        {negocios.map((negocio) => (
          <Typography key={negocio.id} variant="body1" gutterBottom>
            {negocio.descripcion}
          </Typography>
        ))}
      </div>
    </Container>
  );
};

export default GestionNegocioComponent;